import { Door, DoorPayload } from "./door";
import {
  WithDimensionAndTimestamps,
} from "./withDimension";

export type LockerPayload = {
  id?: string,
  type: string,
  origin_x_cm: number,
  origin_y_cm: number,
  width_cm: number,
  height_cm: number,
  hardware_index: number,
  label: string,
  enabled: boolean,
  accessible: boolean,
  doors: Array<DoorPayload>
}

export class Locker implements WithDimensionAndTimestamps {
  public origin_x_cm = 0;
  public origin_y_cm = 0;
  public width_cm = 1;
  public height_cm = 1;
  public id = '';
  public type = 'ambient';
  public hardware_index = 0;
  public label = '';
  public enabled = true;
  public accessible = false;
  public doors: Door[] = [];
  public properties: object = {};
  public board_id = '';
  
  static payload(args: Locker, isNew = false): LockerPayload {
    const payload: LockerPayload = {
        id: args.id,
        type: args.type,
        origin_x_cm: args.origin_x_cm,
        origin_y_cm: args.origin_y_cm,
        width_cm: args.width_cm,
        height_cm: args.height_cm,
        hardware_index: args.hardware_index,
        label: args.label,
        enabled: args.enabled,
        accessible: args.accessible,
        doors: Door.doorsPayload(args.doors)
      };
      
      if (isNew) {
        const {id: _, ...sanitized} = payload;
        return sanitized;
      }
  
      return payload;
  }

  static lockersPayload(args: Array<Locker>, isNew = false): Array<LockerPayload> {
    const temp = [];
    for (const locker of args) {
      temp.push(Locker.payload(locker, isNew));
    }

    return temp;
  }
}
